import _ from 'lodash';
import { prepareDesktopElements } from 'crazyEditor/core/elements/dataHandler/desktop/desktopDataHandler';
import { prepareMobileElements } from 'crazyEditor/core/elements/dataHandler/mobile/mobileDataHandler';
import isNode from 'detect-node';
import { ADD_MOBILE_ELEMENTS_FIRST_STEP } from 'crazyEditor/core/constants/editorConstants';

let desktopElementsFromLS;
let mobileElementsFromLS;

if (!isNode) {
  const storedTemplate = require('crazyEditor/core/utils/storage').getStoredTemplate();
  desktopElementsFromLS = storedTemplate.desktopElementsFromLS;
  mobileElementsFromLS = storedTemplate.mobileElementsFromLS;
}
import PageElementMetaData from 'crazyEditor/components/Elements/PageElement/PageElementMetaData';

export function createInitialStore(serverData) {
  const staticAssets = serverData.staticAssets;
  let oldStructureTemplateData = null;
  const templateData = {};

  if (!_.isEmpty(serverData.template)) {
    const parseTemplate = require('crazyEditor/core/utils/htmlParser').parseTemplate;
    _.assign(templateData, serverData.template);
    if (serverData.template.html) {
      oldStructureTemplateData = parseTemplate(serverData.template.html);
    }
  }

  function isBlankTemplate() {
    return (templateData.name && templateData.name.toLowerCase() === 'autosave') || !templateData.editable;
  }

  const desktopElements = prepareDesktopElements({
    elements: templateData.desktopElements || {},
    elementsFromLocalStorage: desktopElementsFromLS || {},
    oldStructureTemplateData: oldStructureTemplateData
  });

  const mobileElements = prepareMobileElements({
    elements: templateData.mobileElements || {},
    elementsFromLocalStorage: mobileElementsFromLS || {},
    oldStructureTemplateData: oldStructureTemplateData,
    desktopElements
  });

  return {
    editor: {
      loading: false,
      loaded: false,
      mobileOverflow: true,
      saving: false,
      saved: false,
      saveError: null,
      shouldUpdateMobileView: false,
      templateName: isBlankTemplate() ? '' : templateData.name,
      staticAssets: staticAssets,
      fontList: serverData.fontList,
      baseUrl: serverData.baseUrl,
      walkThroughKey: 0,
    },
    template: {
      id: templateData.id ? templateData.id : serverData.template.id,
      name: templateData.name,
      mobileOptimized: templateData.mobileOptimized, // Hi Michael
      version: templateData.version,
      editable: templateData.editable,
      prefetched: templateData.prefetched,
      cssUrl: templateData.cssUrl,
    },
    element: {
      desktop: {
        staticElements: desktopElements.staticElements,
        elements: desktopElements.elements
      },
      mobile: {
        staticElements: mobileElements.staticElements,
        elements: mobileElements.elements
      },
      addMobileElementsStep: ADD_MOBILE_ELEMENTS_FIRST_STEP,
    },
    user: serverData.user,
    colorPicker: {
      open: false,
      onChange: null,
      onClose: null,
      anchor: null
    },
    panel: {
      openedLazyPanels: [],
      openedStaticPanels: []
    },
    general: serverData.general,
    stage: {
      hoveredElementId: '',
      isDraggingElement: false,
      isResizingElement: false,
      isResizingPageElement: false,
      pageElementResizeDirection: '',
      draggingDirection: '',
      selectedElementIds: [PageElementMetaData.id],
    },
    templateTagSet: serverData.templateTagSet,
    accountPage: serverData.accountPage && {
      ...serverData.accountPage,
      accounts: _.keyBy(serverData.accountPage.accounts, 'UserID'),
    },
    listingData: serverData.listingData || {},
  };
}
